module.exports = __webpack_public_path__ + "static/android-icon-192x192-a70c188d9f69cbd06f6edb4bf27fc9d2.png";